import {NgModule} from '@angular/core';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {BpmnProcessEffects, ExecutedPathEffects} from './store';
import {BpmnEngineService} from './services/bpmn-engine.service';
import {BpmnViewerComponent} from './bpmn-viewer.component/bpmn-viewer.component';
import {BpmnViewerService} from './services/bpmn-viewer.service';
import {UserClicksElementsEffects} from './store/effects/user-clicks-elements.effects';
import {ProcessExecutorBackendMockModule} from '@ispm-client/modules/backend-mock-modules/process-executor-backend-mock';
import {environment} from '../../environments/environment';
import {HttpClientModule} from '@angular/common/http';
import {WidgetsModule} from '@ispm/widgets/widgets.module';
import {BpmnXmlService} from '@ispm/shared/bpmn/services/bpmn-xml.service';
import {UserClicksElementsService} from './services';
import {LayoutModule} from '@ispm/layout/layout.module';
import {BpmnGuidedBoxService} from './services/bpmn-guided-box.service';
import {SharedModule} from '@ispm/shared/shared.module';
import {BpmnExecutionComponent} from './bpmn-execution.component/bpmn-execution.component';
import {CoreModule} from '@ispm/core/core.module';
import {metaReducers, processExecuterMetaReducerA} from '@ispm-client/modules/process-executor/store/reducers/reducers';


@NgModule({
    imports: [
        CoreModule,
        LayoutModule,
        SharedModule,
        StoreModule.forFeature('BpmnProcess', processExecuterMetaReducerA, {metaReducers}),
        HttpClientModule,
        WidgetsModule,
        environment.production ? [] : ProcessExecutorBackendMockModule.forRoot(),
        EffectsModule.forFeature([BpmnProcessEffects, ExecutedPathEffects, UserClicksElementsEffects
        ])
    ],
  providers: [
    BpmnXmlService,
    BpmnViewerService,
    BpmnEngineService,
    UserClicksElementsService,
    BpmnGuidedBoxService
    ],
  declarations: [BpmnViewerComponent, BpmnExecutionComponent],
  exports: [
    BpmnViewerComponent,
    BpmnExecutionComponent
  ]
})
export class ProcessExecutorModule { }
